module.exports = __webpack_public_path__ + "static/media/ladPay.8224e5d0.png";